var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlushCloseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0209 3.68681C17.2161 3.49154 17.2161 3.17496 17.0209 2.9797C16.8256 2.78444 16.509 2.78444 16.3138 2.9797L10.0007 9.29281L3.68754 2.9797C3.49228 2.78444 3.17569 2.78444 2.98043 2.9797C2.78517 3.17496 2.78517 3.49154 2.98043 3.68681L9.29354 9.99992L2.98043 16.313C2.78517 16.5083 2.78517 16.8249 2.98043 17.0201C3.17569 17.2154 3.49228 17.2154 3.68754 17.0201L10.0007 10.707L16.3138 17.0201C16.509 17.2154 16.8256 17.2154 17.0209 17.0201C17.2161 16.8249 17.2161 16.5083 17.0209 16.313L10.7078 9.99992L17.0209 3.68681Z",
    fill: "#DD3E1F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlushCloseIcon);
export default __webpack_public_path__ + "static/media/blush-close-icon.bf1de7c320e6696b0c4cf49e0c8dd1e4.svg";
export { ForwardRef as ReactComponent };